import React from 'react';
import {
    OnOpenChangeCallback,
    useDialogStyles,
} from '../../../hooks/useDialog';
import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
} from '@fluentui/react-components';
import { CloseDialogButton } from '../../../controls/Buttons/CloseButton';
import { ArrowForwardRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { IBrokerConnectionActiveConversationsData } from '../../../model/brokerConnections/IBrokerConnectionActiveConversationsData';
import TransferConversationForm from '../../shared/TransferConversationForm/TransferConversationForm';

export interface TransferConversationDialogProps {
    open: boolean;
    conversationData: IBrokerConnectionActiveConversationsData | null;
    onOpenChange: OnOpenChangeCallback;
}

const TransferConversationDialog: React.FC<TransferConversationDialogProps> = ({
    open,
    conversationData,
    onOpenChange,
}) => {
    const { t } = useTranslation();
    const dialogStyles = useDialogStyles();

    return (
        <Dialog open={open} onOpenChange={(_, data) => onOpenChange(data.open)}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle
                        action={<CloseDialogButton />}
                        className={dialogStyles.title}
                    >
                        <span className={dialogStyles.titleIcon}>
                            <ArrowForwardRegular />
                        </span>
                        <span>
                            {t('ActiveConversations_TransferDialogTitle')}
                        </span>
                    </DialogTitle>
                    <DialogContent>
                        <TransferConversationForm
                            conversationData={conversationData}
                            dialog={{ open, onOpenChange }}
                        />
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default TransferConversationDialog;
